<!-- 講座オーナーサマリー -->
<script setup lang="ts">
  // import { PlanInfo } from "~/entities/PlanInfo";
  interface Props {
    planOwner: Object;
  }
  withDefaults(defineProps<Props>(), {
    planOwner: undefined,
  });

  const isSp = isSpDisplayRef();
  const iconSize = computed<number>(() => {
    return isSp.value ? 40 : 110;
  });
</script>

<template>
  <div>
    <div class="w-100 d-inline-flex justify-start" :class="isSp ? 'align-items-center' : null">
      <div class="mr-2 mr-sm-4">
        <AtomsUserIcon :src="planOwner?.image" :is-owner="true" :width="iconSize" :height="iconSize" />
      </div>
      <div class="">
        <p v-if="planOwner?.investorTitle" class="owner-profile-title">
          {{ planOwner?.investorTitle }}
        </p>
        <p class="owner-profile-name">{{ planOwner?.name }}</p>
        <p v-if="!isSp" class="owner-profile-description mt-2">
          {{ planOwner?.description }}
        </p>
      </div>
    </div>
    <div v-if="isSp" class="mt-2">
      <p class="owner-profile-description">{{ planOwner?.description }}</p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .align-items-center {
    align-items: center;
  }
  .owner-profile-title {
    font-size: 16px;
    font-weight: 700;
    line-height: 1.8em;
    letter-spacing: 0.06em;
  }
  .owner-profile-name {
    font-size: 16px;
    font-weight: 700;
    line-height: 1.8em;
    letter-spacing: 0.06em;
  }
  .owner-profile-description {
    font-size: 16px;
    font-weight: 400;
    line-height: 1.8em;
    letter-spacing: 0.06em;
  }
</style>
